module.exports = __webpack_public_path__ + "static/media/logAttitude.72c7c530.svg";